import {
  AfterViewInit,
  Directive,
  HostListener,
  OnDestroy,
  Optional
} from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DirtyFormService } from '@app/services/dirty-form.service';

@Directive({
  // Se adjunta automáticamente a todos los <form>, con opción de excluir usando [appIgnoreUnsaved]
  selector: 'form:not([appIgnoreUnsaved])',
  standalone: false
})
export class UnsavedFormDirective implements AfterViewInit, OnDestroy {
  private sub!: Subscription;
  // Sólo marcar como dirty si hubo interacción del usuario (evitar efectos de valueChanges programáticos)
  private userInteracted = false;

  constructor(
    private dirtySvc: DirtyFormService,
    @Optional() private fg: FormGroupDirective,
    @Optional() private tf: NgForm
  ) {}

  ngAfterViewInit() {
    const form = this.fg?.form ?? this.tf?.form;
    if (!form) return;
    this.sub = form.valueChanges.subscribe(() => {
      if (this.userInteracted) {
        this.dirtySvc.setDirty();
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload(event: BeforeUnloadEvent) {
    if (this.dirtySvc.isDirty()) {
      event.returnValue = true;
    }
  }

  // Si el formulario se envía (ngSubmit o submit nativo), asumimos que se guardó
  // y limpiamos la marca de "sucio" para evitar el doble diálogo.
  @HostListener('ngSubmit')
  @HostListener('submit')
  onSubmit() {
    this.dirtySvc.reset();
    // reset interaction flag after successful submit
    this.userInteracted = false;
  }

  // Detectar interacción del usuario (input, change, tecleo) para distinguir cambios programáticos
  @HostListener('input', ['$event'])
  onUserInput(_event: Event) {
    this.userInteracted = true;
  }

  @HostListener('change', ['$event'])
  onUserChange(_event: Event) {
    this.userInteracted = true;
  }

  @HostListener('keydown', ['$event'])
  onUserKeydown(_event: KeyboardEvent) {
    this.userInteracted = true;
  }
}
